import React from 'react';
import { useApp } from '../context/AppContext';
import googleCalendarIcon from '../images/google-calendar.svg';

// Format a Date to the ICS/Google format: 20260801T180000Z
const toCalStamp = (date) =>
  date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

const AddToCalendar = () => {
  const { settings } = useApp();
  const { eventDate, eventEndDate, eventDescription, eventLocation } = settings;
  const eventTitle = `CanAm Games ${eventDate.getFullYear()}`;

  const googleUrl = () => {
    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: eventTitle,
      dates: `${toCalStamp(eventDate)}/${toCalStamp(eventEndDate)}`,
      details: eventDescription,
      location: eventLocation,
    });
    return `https://calendar.google.com/calendar/render?${params}`;
  };

  const downloadICS = () => {
    const ics = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//CanAm Event//EN',
      'BEGIN:VEVENT',
      `DTSTART:${toCalStamp(eventDate)}`,
      `DTEND:${toCalStamp(eventEndDate)}`,
      `SUMMARY:${eventTitle}`,
      `DESCRIPTION:${eventDescription}`,
      `LOCATION:${eventLocation}`,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\r\n');

    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = 'canam-event.ics';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
  <div className="add-to-calendar">
    <p className="cal-label">Add to your calendar</p>
    <div className="cal-buttons">
      <a
        href={googleUrl()}
        target="_blank"
        rel="noopener noreferrer"
        className="cal-btn cal-btn-google"
      >
        <img
          src={googleCalendarIcon}
          alt=""
          className="cal-btn-icon"
        />
        Google Calendar
      </a>
      <button className="cal-btn cal-btn-ics" onClick={downloadICS}>
        <span className="cal-btn-icon cal-icon-ics">📅</span>
        Apple / Outlook
      </button>
    </div>
  </div>
  );
};

export default AddToCalendar;
